<article class="panel pb-3" *ngIf="order">
  <form [formGroup]="orderForm">
    <p class="panel-heading">Замовлення #{{ orderId }}</p>
    <div class="order-body">
      <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
        <tr>
          <th>Назва</th>
          <th>Кількість</th>
          <th>Ціна</th>
          <th>Сума</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let product of order?.products; let i = index" [attr.data-index]="i">
          <td>{{ product?.name }}</td>
          <td>{{ product?.quantity }} шт</td>
          <td class="price">{{ product?.price }} {{ currency }}</td>
          <td class="price">{{ product?.totalPrice }} {{ currency }}</td>
        </tr>
        </tbody>
      </table>
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">Сума замовлення</label>
        </div>
        <div class="field-body">
          <div class="field">
            <label>{{ orderTotalPriceWithoutDiscount }} {{ currency }}</label>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">Виставлено замовнику</label>
        </div>
        <div class="field-body">
          <div class="field">
            <label>{{ order.orderTotalPrice }} {{ currency }}</label>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Чек на суму</label>
        </div>
        <div class="field-body">
          <div class="field has-addons">
            <div class="control input-with-error">
              <input class="input" type="number" formControlName="amountReceived" (keyup.enter)="onEnter($event)" >
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">Ви надали знижку</label>
        </div>
        <div class="field-body">
          <div class="field is-grouped">
            <label>{{ discount }} {{ currency }}</label>
            <label class="checkbox-label">
              <input type="checkbox" formControlName="splitDiscount">
              Розділити знижку по товарам
            </label>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Спосіб оплати</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-flex is-flex-direction-column radio-label-group">
              <label>
                <input type="radio" formControlName="paymentMethod" value="cash">
                Готівка
              </label>
              <label>
                <input type="radio" formControlName="paymentMethod" value="card">
                Картка
              </label>
              <label>
                <input type="radio" formControlName="paymentMethod" value="iban">
                За реквізитами (IBAN)
              </label>
              <label>
                <input type="radio" formControlName="paymentMethod" value="accountTransfer">
                Переказ з поточного рахунку
              </label>
              <label>
                <input type="radio" formControlName="paymentMethod" value="monoAcquiring">
                Інтернет еквайринг Mono
              </label>
              <label>
                <input type="radio" formControlName="paymentMethod" value="rozetkaPay">
                Платіж RozetkaPay
              </label>
              <label>
                <input type="radio" formControlName="paymentMethod" value="portmone">
                Платіж Portmone
              </label>
              <label>
                <input type="radio" formControlName="paymentMethod" value="novaPay">
                Платіж NovaPay
              </label>
              <label>
                <input type="radio" formControlName="paymentMethod" value="wayForPay">
                Платіж WayForPay
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Left empty for spacing -->
        </div>
        <div class="field-body">
          <div class="field has-addons" *ngIf="orderForm.valid && !checkLink">
            <div class="control">
              <button class="button is-link"
                      type="button"
                      (click)="createCheck()"
                      [ngClass]="isButtonLoading ? 'is-loading' : ''">
                Видати чек
              </button>
            </div>
          </div>
          <div class="field is-grouped" *ngIf="checkLink">
            <div class="control is-align-items-center is-flex">
              <a class="button is-ghost is-small" [href]="checkLink" target="_blank">{{checkLink}}</a>
            </div>
            <div class="control">
              <div class="button is-white" title="Зберегти файл" (click)="saveFile()">
              <span class="icon">
                <i class="fa-solid fa-download"></i>
              </span>
              </div>
            </div>
            <div class="control">
              <div class="button is-white" title="Копіювати посилання на файл" (click)="copyFileLink()">
              <span class="icon">
                <i class="fa-solid fa-copy"></i>
              </span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
  </form>
</article>
